import { EmploymentStatus } from '~Data';

export const employmentStatusChoices: { [key in EmploymentStatus]: string } = {
  [EmploymentStatus.CurrentlyEmployed]: 'Currently Employed',
  [EmploymentStatus.NotCurrentlyEmployed]: 'Not Currently Employed',
  [EmploymentStatus.Retired]: 'Retired',
  [EmploymentStatus.Student]: 'Student',
};
